import {Component, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'intro-outro-component',
    templateUrl: 'intro-outro.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntroOutroComponent {
    checkedControl = new FormControl();
    checkedControlSubscription: Subscription;
    countControl = new FormControl();
    countControlSubscription: Subscription;
    options = [50, 100, 200];

    @Input() canEdit;
    @Input() checked;
    @Output() checkedChange = new EventEmitter();
    @Input() count;
    @Output() countChange = new EventEmitter();
    @Input() title = '';

    constructor(private cdr: ChangeDetectorRef) {
        this.checkedControlSubscription = this.checkedControl.valueChanges.subscribe(value => {
            this.checked = value;
            this.checkedChange.emit(this.checked);
        });
        this.countControlSubscription = this.countControl.valueChanges.subscribe(value => {
            this.count = value;
            this.countChange.emit(this.count);
        });
    }
    ngOnDestroy() {
        if( this.checkedControlSubscription ) {
           this.checkedControlSubscription.unsubscribe(); 
        }
        if( this.countControlSubscription ) {
            this.countControlSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/intro-outro.component.ts